/**
 * CrossTwinCorrelationsCard — корелациите между близнаците за 60 дни.
 * Преместено от UnifiedHealthTwinCard в „Жива физиологична мрежа",
 * за да е всичко за връзките между близнаците на едно място.
 */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTheme } from "@/theme/ThemeContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CrossTwinCorrelationsCard() {
  const { isDark } = useTheme();
  const [corrData, setCorrData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/health-twin/correlations?days=60`, { timeout: 15000 })
      .then(({ data }) => setCorrData(data))
      .catch(() => { /* новите потребители нямат достатъчно данни */ });
  }, []);

  if (!corrData) return null;

  return (
    <div className={`mt-4 p-4 rounded-xl border ${
      isDark ? "bg-slate-900/40 border-slate-800" : "bg-white border-slate-200"}`}
      data-testid="twin-correlations">
      <div className={`text-[10px] uppercase font-bold mb-2 ${
        isDark ? "text-fuchsia-300" : "text-fuchsia-600"}`}>
        🔗 Cross-Twin корелации (60 дни)
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <CorrTile label="DIL ↔ Когниция" data={corrData.cognitive_vs_dil} isDark={isDark} />
        <CorrTile label="Med адхеренция ↔ HbA1c" data={corrData.hba1c_vs_mediterranean} isDark={isDark} />
        <CorrTile label="Med адхеренция ↔ hsCRP" data={corrData.hscrp_vs_mediterranean} isDark={isDark} />
      </div>
      {corrData.nudges?.length > 0 && (
        <div className="mt-3 space-y-1.5">
          {corrData.nudges.map((n, i) => (
            <div key={i}
              className={`p-2 rounded-lg text-[11px] flex items-start gap-1.5 ${
                n.severity === "high"
                  ? (isDark ? "bg-rose-500/10 border border-rose-500/30 text-rose-200"
                            : "bg-rose-50 border border-rose-200 text-rose-800")
                  : (isDark ? "bg-amber-500/10 border border-amber-500/30 text-amber-200"
                            : "bg-amber-50 border border-amber-200 text-amber-800")}`}
              data-testid={`twin-nudge-${i}`}>
              <span>{n.severity === "high" ? "⚠️" : "🔔"}</span>
              <span>{n.message_bg}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function CorrTile({ label, data, isDark }) {
  if (!data) return null;
  const r = data.pearson_r;
  const color =
    r == null ? "text-slate-400"
    : r > 0.5 ? "text-emerald-500"
    : r > 0.25 ? "text-lime-500"
    : r > -0.25 ? "text-slate-400"
    : r > -0.5 ? "text-amber-500"
    : "text-rose-500";
  return (
    <div className={`p-2 rounded-md ${isDark ? "bg-slate-800/40" : "bg-slate-50"}`}>
      <div className="text-[9px] uppercase font-bold opacity-60">{label}</div>
      <div className={`text-base font-bold ${color}`}>
        {r != null ? `r=${r.toFixed(2)}` : "—"}
      </div>
      <div className="text-[10px] opacity-70 leading-tight" title={data.interpretation_bg}>
        {data.samples} {data.samples === 1 ? "точка" : "точки"}
      </div>
    </div>
  );
}
